import * as Dialog from "@radix-ui/react-dialog";
import type { MouseEvent, ReactNode } from "react";

import styles from "./styles/platform-modal.module.css";

type PlatformModalProps = {
  title: string;
  description?: string;
  children?: ReactNode;
  error?: string | null;
  cancelLabel?: string;
  confirmLabel: string;
  pendingLabel?: string;
  confirmDisabled?: boolean;
  pending?: boolean;
  onClose: () => void;
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
  onConfirmAuxClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

/** The canonical modal shell for Platform forms and confirmations. */
export function PlatformModal({
  title,
  description,
  children,
  error,
  cancelLabel = "Cancel",
  confirmLabel,
  pendingLabel = "Working…",
  confirmDisabled = false,
  pending = false,
  onClose,
  onConfirm,
  onConfirmAuxClick,
}: PlatformModalProps) {
  return (
    <Dialog.Root open onOpenChange={(open) => !open && !pending && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content} aria-describedby={undefined}>
          <Dialog.Title className={styles.title}>{title}</Dialog.Title>
          {description && <p className={styles.description}>{description}</p>}
          {children && <div className={styles.body}>{children}</div>}
          {error && <p className={styles.error}>{error}</p>}
          <div className={styles.actions}>
            <button type="button" className={styles.cancelButton} disabled={pending} onClick={onClose}>{cancelLabel}</button>
            <button type="button" className={styles.submitButton} disabled={pending || confirmDisabled} onClick={onConfirm} onAuxClick={onConfirmAuxClick}>
              {pending ? pendingLabel : confirmLabel}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
